import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

type AuthState = {
	auth: {
		login: {
			isPasswordLogin: boolean;
			isSSOLogin: boolean;
		};
	};
};

type AuthActions = {
	setLoginMethod: ({ isPasswordLogin, isSSOLogin }: Partial<AuthState['auth']['login']>) => void;
};

export type AuthSlice = AuthState & AuthActions;

const authInitialState: AuthState = {
	auth: {
		login: {
			isPasswordLogin: true,
			isSSOLogin: false,
		},
	},
};

export function authSlice(set: NamedSet<ZustandStore>): AuthSlice {
	return {
		...authInitialState,
		setLoginMethod({ isPasswordLogin = false, isSSOLogin = false }: Partial<AuthState['auth']['login']>): void {
			set(
				(state: AuthState) => {
					state.auth.login.isPasswordLogin = isPasswordLogin;
					state.auth.login.isSSOLogin = isSSOLogin;
					return state;
				},
				false,
				'[setLoginMethod]',
			);
		},
	};
}
